var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4747497_social media_facebook_icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3452 1.06543H3.46806C2.69514 1.06543 1.95385 1.37247 1.40731 1.91902C0.860757 2.46558 0.553711 3.20685 0.553711 3.97979V18.8569C0.553711 19.6299 0.860757 20.3712 1.40731 20.9177C1.95385 21.4642 2.69514 21.7713 3.46806 21.7713H10.2389V14.2137H7.67912V11.2657H10.2389V9.09414C10.2389 7.86343 10.5792 6.90708 11.2599 6.22767C11.9406 5.54696 12.8634 5.20532 14.0293 5.20532C15.1966 5.20532 15.9524 5.25061 16.2979 5.33602V7.96049H14.7424C14.1807 7.96049 13.7977 8.07955 13.5919 8.31767C13.3874 8.55449 13.2852 8.91167 13.2852 9.38661V11.2657H16.2009L15.8126 14.2137H13.2852V21.7713H18.3452C19.1182 21.7713 19.8595 21.4642 20.406 20.9177C20.9526 20.3712 21.2596 19.6299 21.2596 18.8569V3.97979C21.2596 3.20685 20.9526 2.46558 20.406 1.91902C19.8595 1.37247 19.1182 1.06543 18.3452 1.06543Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.f79efb84added5926b174f3b7cf06be3.svg";
export { ForwardRef as ReactComponent };